/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderCredentialListConfiguration,
    ProviderCredentialListConfigurationFromJSON,
    ProviderCredentialListConfigurationToJSON,
    ProviderCredentialListItem,
    ProviderCredentialListItemFromJSON,
    ProviderCredentialListItemToJSON,
    ProviderCredentialListQuery,
    ProviderCredentialListQueryFromJSON,
    ProviderCredentialListQueryToJSON,
} from '../models';

export interface ApiProviderCredentialsProviderCredentialListDataPostRequest {
    providerCredentialListQuery?: ProviderCredentialListQuery;
}

/**
 * no description
 */
export class ProviderCredentialListApi extends runtime.BaseAPI {

    /**
     */
    async apiProviderCredentialsProviderCredentialListConfigurationGetRaw(): Promise<runtime.ApiResponse<ProviderCredentialListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentials/ProviderCredentialList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderCredentialListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialListConfigurationGet(): Promise<ProviderCredentialListConfiguration> {
        const response = await this.apiProviderCredentialsProviderCredentialListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialListDataPostRaw(requestParameters: ApiProviderCredentialsProviderCredentialListDataPostRequest): Promise<runtime.ApiResponse<Array<ProviderCredentialListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderCredentials/ProviderCredentialList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProviderCredentialListQueryToJSON(requestParameters.providerCredentialListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderCredentialListItemFromJSON));
    }

    /**
     */
    async apiProviderCredentialsProviderCredentialListDataPost(requestParameters: ApiProviderCredentialsProviderCredentialListDataPostRequest): Promise<Array<ProviderCredentialListItem>> {
        const response = await this.apiProviderCredentialsProviderCredentialListDataPostRaw(requestParameters);
        return await response.value();
    }

}
